/* import __COLOCATED_TEMPLATE__ from './date-question.hbs'; */
import { dateFormat } from 'client-portal/utils/date-time';
import Component from '@glimmer/component';

export default class RequestPrescreenerQuestionTypesDateQuestion extends Component {
  inactivePlaceholder = dateFormat.toLowerCase();
  dateFormat = dateFormat;

  get currentValue() {
    return this.args.validationModel?.value;
  }

  get hasValue() {
    return !!this.currentValue;
  }
}
